
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('mask',{attrs:{"id":"file-alt_svg__a","maskUnits":"userSpaceOnUse","x":"6","y":"4","width":"12","height":"16"}},[_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M14.938 4.468l2.621 2.616c.282.281.441.665.441 1.06v10.359c0 .826-.672 1.497-1.5 1.497h-9c-.828 0-1.5-.67-1.5-1.497V5.528c0-.826.672-1.497 1.5-1.5h6.378c.397 0 .778.159 1.06.44zm2.046 3.555a.49.49 0 00-.13-.23L14.23 5.174a.492.492 0 00-.231-.13v2.978h2.984zM16.5 19.002h-9a.501.501 0 01-.5-.5V5.529c0-.275.225-.5.5-.5H13v3.245c0 .414.334.748.75.748H17v9.482c0 .274-.225.499-.5.499zM15 11.64v-.25a.376.376 0 00-.375-.374h-5.25a.376.376 0 00-.375.374v.25c0 .206.169.374.375.374h5.25a.376.376 0 00.375-.374zm0 1.746v.25a.376.376 0 01-.375.374h-5.25A.376.376 0 019 13.637v-.25c0-.205.169-.374.375-.374h5.25c.206 0 .375.169.375.374zm0 2.246v-.25a.376.376 0 00-.375-.374h-5.25a.376.376 0 00-.375.375v.25c0 .205.169.373.375.373h5.25a.376.376 0 00.375-.374z","fill":"#fff"}})]),_c('g',{attrs:{"mask":"url(#file-alt_svg__a)"}},[_c('path',{attrs:{"fill":"#330E2F","d":"M0 0h24v24H0z"}})])])
          )
        }
      }
    